export const ROLE_CONSTANTS =  {
  'DIRECTOR':1,
  'PURCHASE':26,
  'ADMIN':3,
  'CHIEF_ENGINEER': 4,
  'ACCOUNTANT': 15,
  'ENGINEER': 25,
  'WAREHOUSE_KEEPER': 2,
}
